import React from 'react';

function StatCard({ label, value, helper, icon }) {
  return (
    <div className="rounded-xl border border-gray-100 bg-white p-5 shadow-sm dark:border-neutral-800 dark:bg-neutral-900">
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="text-xs font-bold uppercase tracking-wider text-gray-400">{label}</p>
          <p className="mt-2 text-3xl font-bold text-gray-900 dark:text-neutral-100">{value}</p>
        </div>
        {icon && (
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-blue-50 text-blue-700 dark:bg-neutral-800 dark:text-neutral-200">
            {icon}
          </div>
        )}
      </div>
      {helper && <p className="mt-3 text-sm text-gray-500 dark:text-neutral-400">{helper}</p>}
    </div>
  );
}

export default StatCard;
